// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-agenda--element {
  background-color: var(--agenda-bg-color);
}
.block-agenda--element .block-agenda__title {
  color: var(--sections-title-color) !important;
}
.block-agenda--element .agenda-card__title,
.block-agenda--element .agenda-card__nested-title {
  color: var(--agenda-title-color) !important;
}
.block-agenda--element .agenda-card__paragraph,
.block-agenda--element .agenda-card__speakers-container-label {
  color: var(--agenda-description-color) !important;
}
.block-agenda--element .agenda-card__content {
  background-color: var(--agenda-card-bg-color) !important;
  border-right: 0;
  background-color: var(--agenda-card-bg-color) !important;
  border-top: 1px solid var(--default-border-color) !important;
  border-bottom: 1px solid var(--default-border-color) !important;
  border-left: 0;
}
.block-agenda--element .agenda-card__collapsible {
  background-color: var(--agenda-card-bg-color) !important;
  border: 1px solid var(--default-border-color) !important;
}
.block-agenda--element .agenda-card__time {
  color: var(--agenda-time-color) !important;
}
.block-agenda--element .agenda-card__timing {
  color: var(--agenda-timing-color) !important;
  font-weight: var(--agenda-timing-font-weight) !important;
}
.block-agenda--element .agenda-card__speaker .ant-card-meta-title {
  color: var(--agenda-speaker-text-color) !important;
  font-weight: 500;
}
.block-agenda--element .agenda-card__speaker .ant-card-meta-avatar {
  padding-right: 10px;
}
.block-agenda--element .block-agenda__tabs-container .ant-tabs-tab {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, padding 0.2s ease;
}
.block-agenda--element .block-agenda__tabs-container.fixedTabs {
  margin: 0 !important;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-mobile));
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__tabs-container.fixedTabs {
    top: calc(var(--navbar-height-desktop));
  }
}
.block-agenda--element .block-agenda__tabs-container--hide-xs {
  display: none;
}
@media (min-width: 992px) {
  .block-agenda--element .block-agenda__tabs-container--hide-lg {
    display: none;
  }
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__tabs-container--hide-xl {
    display: none;
  }
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-expand-icon,
.block-agenda--element .agenda-card__collapsible .ant-collapse-expand-icon span {
  font-size: 14px !important;
  color: var(--agenda-title-color) !important;
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-header {
  padding: var(--agenda-card-padding) !important;
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-item {
  border-bottom: 0;
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-content-box {
  padding: var(--agenda-card-padding) !important;
}
.block-agenda--element {
  /* === START AGENDA COLUMNS ==== */
}
.block-agenda--element .block-agenda__agenda-columns {
  display: none;
}
.block-agenda--element .block-agenda__agenda-columns--show-xs {
  display: block;
}
@media (min-width: 992px) {
  .block-agenda--element .block-agenda__agenda-columns--show-lg {
    display: block;
  }
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__agenda-columns--show-xl {
    display: block;
  }
}
.block-agenda--element .block-agenda__column-title {
  color: var(--sections-title-color) !important;
  margin: 0 !important;
  padding: 20px;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-mobile));
  border-bottom: 1px solid var(--default-border-color);
  margin-bottom: 30px !important;
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__column-title {
    top: calc(var(--navbar-height-desktop));
  }
}
.block-agenda--element {
  /* === START AGENDA TABLE ==== */
}
.block-agenda--element .block-agenda__agenda-table {
  display: none;
  margin-top: -10px;
}
.block-agenda--element .block-agenda__agenda-table--show-xs {
  display: block;
}
@media (min-width: 992px) {
  .block-agenda--element .block-agenda__agenda-table--show-lg {
    display: block;
  }
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__agenda-table--show-xl {
    display: block;
  }
}
.block-agenda--element .block-agenda__agenda-table .ant-col .ant-col:first-of-type {
  margin-top: 30px;
}
.block-agenda--element .block-agenda__agenda-table.reducedMargin .ant-col .ant-col {
  margin-top: 0px;
}
.block-agenda--element .block-agenda__agenda-table .agenda-column {
  scroll-margin: 5rem;
}
.block-agenda--element .block-agenda__table-title {
  margin: 0 !important;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title {
    padding-right: 30px;
  }
}
.block-agenda--element .block-agenda__table-title .ant-tag {
  font-size: 16px;
  padding: 7px;
  white-space: initial !important;
  color: var(--sections-title-color) !important;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title .ant-tag {
    font-size: 18px;
  }
}
.block-agenda--element .block-agenda__table-title-content {
  margin: 0 !important;
  padding: 20px 0px;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-mobile));
  border-bottom: 1px solid var(--default-border-color);
  display: flex;
  align-items: center;
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__table-title-content {
    top: calc(var(--navbar-height-desktop));
  }
}
.block-agenda--element .block-agenda__table-title-content.notSticky {
  position: relative;
  top: 0;
  z-index: 0;
}
.block-agenda--element .block-agenda__table-title-content > *:nth-child(1) {
  flex-basis: 100%;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title-content > *:nth-child(1) {
    display: block;
    flex-basis: 55%;
  }
}
.block-agenda--element .block-agenda__table-title-content > *:nth-child(2) {
  display: none;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title-content > *:nth-child(2) {
    display: block;
    flex-basis: 20%;
  }
}
.block-agenda--element .block-agenda__table-title-content > *:nth-child(3) {
  display: none;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title-content > *:nth-child(3) {
    display: block;
    flex-basis: 25%;
  }
}
.block-agenda--element .block-agenda__table-title-timings {
  color: var(--sections-title-color) !important;
  font-weight: 600;
  font-size: 17px;
}
.block-agenda--element .block-agenda__table-title-speakers {
  color: var(--sections-title-color) !important;
  font-weight: 600;
  font-size: 17px;
}
.block-agenda--drawer {
  background-color: var(--agenda-drawer-bg-color);
}
.block-agenda--drawer .agenda-card__title {
  font-size: 18px !important;
}
@media (min-width: 992px) {
  .block-agenda--drawer .agenda-card__title {
    font-size: 20px !important;
  }
}
.block-agenda--drawer .agenda-card__title,
.block-agenda--drawer .agenda-card__nested-title {
  color: var(--agenda-drawer-title-color) !important;
}
.block-agenda--drawer .agenda-card__paragraph,
.block-agenda--drawer .agenda-card__speakers-container-label {
  color: var(--agenda-drawer-title-color) !important;
}
.block-agenda--drawer .agenda-card__collapsible {
  background-color: transparent !important;
}
.block-agenda--drawer .agenda-card__time {
  color: var(--agenda-drawer-time-color);
}
.block-agenda--drawer .agenda-card__timing {
  color: var(--agenda-drawer-time-color);
}
.block-agenda--drawer .agenda-card__speaker .ant-card-meta-title {
  color: var(--agenda-drawer-speaker-name-color) !important;
  font-weight: 500;
}
.block-agenda--drawer .agenda-card__speaker .ant-card-meta-avatar {
  padding-right: 10px;
}
.block-agenda--drawer .agenda-card__wrapper {
  padding: 10px 0 30px !important;
}
.block-agenda--drawer .agenda-card__collapsible .ant-collapse-header {
  padding: 10px 0 30px !important;
}
.block-agenda--drawer .agenda-card__collapsible .ant-collapse-expand-icon,
.block-agenda--drawer .agenda-card__collapsible .ant-collapse-expand-icon span {
  font-size: 16px;
  color: var(--agenda-title-color) !important;
}
.block-agenda--drawer .agenda-card__content--list-item {
  border-radius: 0px;
  border-bottom: 1px solid var(--default-border-color);
}
.block-agenda .episode-details {
  margin-bottom: 3em;
}
.block-agenda .block-agenda__episode-speakers {
  margin-bottom: 2em;
}

.agenda-table-col-item .ant-collapse-expand-icon {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Agenda/Agenda.scss"],"names":[],"mappings":"AAGI;EACI,wCAAA;AAFR;AAIQ;EACI,6CAAA;AAFZ;AAKQ;;EAEI,2CAAA;AAHZ;AAMQ;;EAEI,iDAAA;AAJZ;AAOQ;EACI,wDAAA;EAEA,eAAA;EACA,wDAAA;EACA,4DAAA;EACA,+DAAA;EACA,cAAA;AANZ;AASQ;EACI,wDAAA;EACA,wDAAA;AAPZ;AAUQ;EACI,0CAAA;AARZ;AAWQ;EACI,4CAAA;EACA,wDAAA;AATZ;AAYQ;EACI,kDAAA;EACA,gBAAA;AAVZ;AAaQ;EACI,mBAAA;AAXZ;AAiBY;EACI,kGAAA;AAfhB;AAkBY;EACI,oBAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAhBhB;AAkBgB;EAVJ;IAWQ,uCAAA;EAflB;AACF;AAkBY;EACI,aAAA;AAhBhB;AAoBgB;EADJ;IAEQ,aAAA;EAjBlB;AACF;AAqBgB;EADJ;IAEQ,aAAA;EAlBlB;AACF;AAuBY;;EAEI,0BAAA;EACA,2CAAA;AArBhB;AAwBY;EACI,8CAAA;AAtBhB;AAyBY;EACI,gBAAA;AAvBhB;AA0BY;EACI,8CAAA;AAxBhB;AAjFI;EA6GI,kCAAA;AAzBR;AA0BQ;EACI,aAAA;AAxBZ;AA0BY;EACI,cAAA;AAxBhB;AA4BgB;EADJ;IAEQ,cAAA;EAzBlB;AACF;AA6BgB;EADJ;IAEQ,cAAA;EA1BlB;AACF;AA8BQ;EACI,6CAAA;EACA,oBAAA;EACA,aAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,sCAAA;EACA,oDAAA;EACA,8BAAA;AA5BZ;AA8BY;EAXJ;IAYQ,uCAAA;EA3Bd;AACF;AApHI;EAkJI,gCAAA;AA3BR;AA4BQ;EACI,aAAA;EACA,iBAAA;AA1BZ;AA4BY;EACI,cAAA;AA1BhB;AA8BgB;EADJ;IAEQ,cAAA;EA3BlB;AACF;AA+BgB;EADJ;IAEQ,cAAA;EA5BlB;AACF;AAgCY;EACI,gBAAA;AA9BhB;AAkCgB;EACI,eAAA;AAhCpB;AAoCY;EACI,mBAAA;AAlChB;AAsCQ;EACI,oBAAA;AApCZ;AAsCY;EAHJ;IAIQ,mBAAA;EAnCd;AACF;AAqCY;EACI,eAAA;EACA,YAAA;EACA,+BAAA;EACA,6CAAA;AAnChB;AAqCgB;EANJ;IAOQ,eAAA;EAlClB;AACF;AAsCQ;EACI,oBAAA;EACA,iBAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,sCAAA;EACA,oDAAA;EACA,aAAA;EACA,mBAAA;AApCZ;AAsCY;EAXJ;IAYQ,uCAAA;EAnCd;AACF;AAqCY;EACI,kBAAA;EACA,MAAA;EACA,UAAA;AAnChB;AAsCY;EACI,gBAAA;AApChB;AAsCgB;EAHJ;IAIQ,cAAA;IACA,eAAA;EAnClB;AACF;AAsCY;EACI,aAAA;AApChB;AAsCgB;EAHJ;IAIQ,cAAA;IACA,eAAA;EAnClB;AACF;AAsCY;EACI,aAAA;AApChB;AAsCgB;EAHJ;IAIQ,cAAA;IACA,eAAA;EAnClB;AACF;AAuCQ;EACI,6CAAA;EACA,gBAAA;EACA,eAAA;AArCZ;AAwCQ;EACI,6CAAA;EACA,gBAAA;EACA,eAAA;AAtCZ;AA0CI;EACI,+CAAA;AAxCR;AA0CQ;EACI,0BAAA;AAxCZ;AA0CY;EAHJ;IAIQ,0BAAA;EAvCd;AACF;AA0CQ;;EAEI,kDAAA;AAxCZ;AA2CQ;;EAEI,kDAAA;AAzCZ;AA4CQ;EACI,wCAAA;AA1CZ;AA6CQ;EACI,sCAAA;AA3CZ;AA8CQ;EACI,sCAAA;AA5CZ;AA+CQ;EACI,yDAAA;EACA,gBAAA;AA7CZ;AAgDQ;EACI,mBAAA;AA9CZ;AAiDQ;EACI,+BAAA;AA/CZ;AAmDY;EACI,+BAAA;AAjDhB;AAoDY;;EAEI,eAAA;EACA,2CAAA;AAlDhB;AAsDQ;EACI,kBAAA;EACA,oDAAA;AApDZ;AAwDI;EACI,kBAAA;AAtDR;AAyDI;EACI,kBAAA;AAvDR;;AA4DI;EACI,wBAAA;AAzDR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
